export const getReferralCaseDefaults = (wufooData) => {
  const fileNumber = wufooData?.FileNumber;
  const hoursPerSession = Number(wufooData?.HoursPerSession ?? 0);
  const numberOfSessions = Number(wufooData?.NoOfSessions ?? 0);
  const calculatedHoursLimit = hoursPerSession * numberOfSessions;
  const caseTypeSource = `${wufooData?.CaseType722C ?? ""}${wufooData?.CaseTypePvtPay ?? ""}`;

  return {
    docketNumber: fileNumber == null ? "" : String(fileNumber),
    voucherNumber: fileNumber == null ? "" : String(fileNumber),
    hoursLimit: Number.isFinite(calculatedHoursLimit)
      ? calculatedHoursLimit
      : 0,
    caseType: caseTypeSource.includes("Private") ? "Private" : "Public",
  };
};
